module.exports = __webpack_public_path__ + "img/evaluate_01.7bb825f9.png";